<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="询价单"> </pageTitle>
    <basicList :config="basicListconfig" @search="searchEvent">
      <template v-slot:status="row">
        {{
          row.row.status == 1
            ? "询价中"
            : row.row.status == 2
            ? "已报价"
            : row.row.status == 3
            ? "已采购"
            : row.row.status == 0
            ? "已取消"
            : "--"
        }}
      </template>
      <template v-slot:operation="row">
        <div class="button button_modify" @click="preview(row.row)">
          <i class="iconfont icon-yulanmoban"></i> 查看
        </div>
        <div
          class="button button_modify"
          v-if="row.row.status == 1 || row.row.status == 2"
          @click="cancel(row.row)"
        >
          <i class="iconfont icon-quxiao"></i>取消
        </div>
        <div
          class="button button_modify"
          v-if="row.row.status == 2"
          @click="purchase(row.row)"
        >
          <i class="iconfont icon-xunjia"></i>采购
        </div>
      </template>
    </basicList>
    <el-dialog
      :visible.sync="visible"
      width="1200px"
      custom-class="addProductPopUpWindow"
      @close="close"
    >
      <div id="printArea">
        <div class="formtitle">
          <h2>询价单</h2>
        </div>
        <p style="padding-bottom: 10px">询价单号：{{ currentObj.no }}</p>
        <div class="table2">
          <table>
            <tr>
              <th>品名</th>
              <th>上次供货价</th>
              <th>本次报价</th>
              <th>最近采购价</th>
              <th>差价</th>
              <th>数量</th>
              <th>小计</th>
              <th v-if="currentObj.status == 1 || currentObj.status == 2">
                操作
              </th>
            </tr>
            <tr v-for="(n, i) in detailsConfiguration.data" :key="i">
              <td>
                {{ n.item_name }}
              </td>
              <td>
                {{ n.supply_price }}
              </td>
              <td>
                {{ n.quotation_price }}
              </td>
              <td>
                {{ n.last_price }}
              </td>
              <td>
                {{ n.fall_price }}
              </td>
              <td>
                {{ n.item_num }}
              </td>
              <td>
                {{ n.subtotal }}
              </td>
              <td v-if="currentObj.status == 1 || currentObj.status == 2">
                <el-button type="text" @click="removeTheRow(n)">移除</el-button>
              </td>
            </tr>
          </table>
        </div>
        <div style="display: flex; justify-content: space-between">
          <ul class="ullist" style="flex-wrap: wrap">
            <li style="width: 100%">
              <span>联系人：</span>{{ currentObj.user.name }}
            </li>
            <li style="width: 100%">
              <span>联系电话：</span>{{ currentObj.user.phone }}
            </li>
            <li style="width: 100%">
              <span>送货地址：</span>{{ currentObj.shop.address }}
            </li>
            <li style="width: 100%">
              <span>询价日期：</span>{{ currentObj.inquiry_at }}
            </li>
          </ul>
          <img style="width: 120px; height: 120px" :src="qrcodeurl" />
        </div>
      </div>
      <!-- <basicList :config="detailsConfiguration">
        <template v-slot:operation="row">
          <div class="button button_modify" @click="deleteItem(row.row)">
            <i class="iconfont icon-shanchu"></i> 移除
          </div>
        </template>
      </basicList> -->
      <div slot="footer">
        <el-button
          type="info"
          v-if="currentObj.status == 1 || currentObj.status == 2"
          @click="cancelInquiry"
          >取消询价</el-button
        >
        <el-button
          type="primary"
          v-if="currentObj.status == 2 && displayButtons"
          @click="purchase({ no: currentObj.no })"
        >
          生成预采购单</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getRoles } from "@/utils";
import {
  itemClassGetList,
  supplierGetList,
  getshoplist,
} from "@/api/basicConfiguration";
import QRCode from "qrcode";
import {
  getInquiryList,
  getInquiryDetail,
  removeInquiryItem,
  removeInquiry,
  updateOrderStatus,
} from "@/api/pendingReplenishmentOrder";
// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
import { preOrderBuyAdd } from "@/api/purchasing";
export default {
  name: "inquirySheet",
  data() {
    return {
      displayButtons: true,
      qrcodeurl: "",
      designatedSupplier: null,
      supplierlist: [],
      shopId: null,
      isItDisplayed: false,
      detailsConfiguration: {
        loading: false,
        height: "calc(100vh - 350px)",
        search: false,
        data: [],
        column: [
          {
            label: "品名",
            prop: "item_name",
          },
          {
            label: "上次供货价",
            prop: "supply_price",
            isMoney: true,
          },
          {
            label: "本次报价",
            prop: "quotation_price",
            isMoney: true,
          },
          {
            label: "最近采购价",
            prop: "last_price",
            isMoney: true,
          },
          {
            label: "差价",
            prop: "fall_price",
            isMoney: true,
          },
          {
            label: "数量",
            prop: "item_num",
          },
          {
            label: "小计",
            prop: "subtotal",
          },
        ],
        isPage: false,
        operation: true,
        operationWidth: 110,
        total: 0,
        searchParameters: {},
      },
      // 列表组件参数
      basicListconfig: {
        loading: false,
        height: "calc(100vh - 350px)",
        search: [
          {
            label: "所属门店",
            type: "select",
            options: [],
            key: "shop_id",
            value: "",
          },
          {
            label: "供应商",
            type: "select",
            options: [],
            key: "supplier_id",
          },
        ],
        data: [],
        column: [
          {
            label: "门店",
            prop: "shop_name",
            width: 150,
          },
          {
            label: "供应商",
            prop: "supplier_name",
            width: 300,
          },
          {
            label: "商品数量",
            prop: "item_count",
            width: 100,
          },
          {
            label: "询价总金额",
            prop: "supply_price",
            width: 150,
          },
          {
            label: "报价总金额",
            prop: "quotation",
            width: 150,
          },
          {
            label: "差价",
            prop: "price_diff",
            width: 150,
          },
          {
            label: "询价日期",
            prop: "inquiry_at",
            width: 200,
          },
          {
            label: "报价日期",
            prop: "quotation_at",
            width: 200,
          },
          {
            label: "状态",
            prop: "status",
            slot: true,
            width: 200,
          },
          {
            label: "询价单号",
            prop: "no",
            width: 200,
          },
        ],
        isPage: true,
        operation: true,
        operationWidth: 240,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      title: "",
      visible: false,
      storeList: [],
      currentObj: {
        user: {},
        shop: {},
      },
    };
  },
  created() {
    this.getDataSource().then((res) => {
      // 有主门店直接查询主门店下数据;
      if (this.$store.getters.userInfo.shopId) {
        // 搜索框赋值
        this.basicListconfig.search.map((item) => {
          if (item.key == "shop_id") {
            item.value = this.$store.getters.userInfo.shopId;
          }
          return item;
        });
        // 没有主门店手动选择门店可查看;
        this.basicListconfig.searchParameters.shop_id = Number(
          this.$store.getters.userInfo.shopId
        );
        this.getlist();
      } else {
      }
    });
  },
  methods: {
    removeTheRow(row) {
      console.log(
        "%c [ row ]-321",
        "font-size:13px; background:pink; color:#bf2c9f;",
        row
      );
      this.$confirm("将移除该商品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((res) => {
          removeInquiryItem({
            inquiry_id: this.currentObj.id,
            item_id: row.item_id,
          }).then((res) => {
            if (res.code == 200) {
              getInquiryDetail({ no: this.currentObj.no }).then((res) => {
                this.detailsConfiguration.data = res.data.items;
              });
            }
          });
        })
        .catch((rej) => {
          // console.log('用户取消了操作');
        });
    },

    purchase(row) {
      this.$confirm("将要生成预采购单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((res) => {
          this.displayButtons = false;
          getInquiryDetail({ no: row.no }).then((res) => {
            let num = res.data.items.reduce(
              (sum, item) => sum + Number(item.item_num),
              0
            );
            let data = {
              order_info: {
                shop_id: res.data.shop.id,
                comp_id: res.data.shop.comp_id,
                supplier_id: res.data.supplier.id,
                user_id: res.data.user.id,
                num: num,
                trans_type: 0,
                total_money: "",
                payed_money: 0,
                remark: "",
              },

              order_list: res.data.items.map((item) => {
                return {
                  item_id: item.item_id,
                  num: Number(item.item_num),
                  price_distribution: item.price_distribution,
                  total_money: Number(
                    (
                      Number(item.item_num) * Number(item.quotation_price)
                    ).toFixed(2)
                  ),
                  package_num: item.package_num,
                  single_num: item.single_num,
                  price_new: item.quotation_price,
                  avg_price: item.avg_price,
                  price_outstock: item.price_outstock,
                };
              }),
              pay_list: [],
            };
            preOrderBuyAdd(data).then((res) => {
              if (res.code == 1) {
                updateOrderStatus({ id: this.currentObj.id }).then((res) => {
                  if (res.code == 200) {
                    this.$message.success("操作成功");
                    this.getlist();
                  } else {
                    this.displayButtons = true;
                    this.$message.error(res.msg);
                  }
                });
              } else {
                this.$message.error(res.data.msg);
                this.displayButtons = true;
              }
            });
          });
        })
        .catch((rej) => {
          // console.log('用户取消了操作');
        });
    },
    cancel(row) {
      this.$confirm("将要取消本次询价, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((res) => {
          removeInquiry({ inquiry_id: row.id }).then((res) => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.visible = false;
              this.getlist();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch((rej) => {
          // console.log('用户取消了操作');
        });
    },
    generateQRCode(text) {
      return QRCode.toDataURL(text, { errorCorrectionLevel: "H" })
        .then((url) => {
          return url;
        })
        .catch((err) => {
          console.error(err);
          return null; // 或者返回一个错误图片的 URL
        });
    },
    // 取消询价
    cancelInquiry() {
      removeInquiry({ inquiry_id: this.currentObj.id }).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.visible = false;
          this.getlist();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    preview(row) {
      this.title = "供应商：" + row.supplier_name + "  询价单号：" + row.no;
      this.visible = true;
      getInquiryDetail({ no: row.no }).then((res) => {
        this.currentObj = res.data;

        this.detailsConfiguration.data = res.data.items.map((item) => {
          item.supply_price = res.data.supply_price;
          return item;
        });
      });
      this.generateQRCode(row.no).then((res) => {
        this.qrcodeurl = res;
      });
    },
    close() {
      this.visible = false;
    },
    // 搜索事件
    searchEvent(data, page, pageSize) {
      localStorage.setItem("search", JSON.stringify(data));
      if (page || pageSize) {
        if (page) this.basicListconfig.searchParameters.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.search.map((item) => {
        if (item.key == "shop_id") {
          item.value = this.basicListconfig.searchParameters.shop_id;
        }
        return item;
      });
      this.basicListconfig.loading = true;
      this.basicListconfig.searchParameters["comp_id"] = this.compId;
      getInquiryList(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 200) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data.data;
          this.basicListconfig.total = res.data.count;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
    searchForInquiryData(val) {
      this.searchEvent({ supplier_id: val });
    },
    // 获取数据源
    async getDataSource() {
      const res = await getshoplist({
        status: 0,
        comp_id: JSON.parse(getRoles()).comp_id,
      });
      if (res.code == 1) {
        this.basicListconfig.search.map((item) => {
          if (item.key == "shop_id") {
            item.options = this.storeList = res.data.map((item) => {
              return {
                label: item.name,
                value: item.id,
              };
            });
          }
          return item;
        });
      } else {
        this.$message.error(res.msg);
      }
      itemClassGetList().then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "class_id") {
              item.options = this.$findChildren(0, res.data);
            }
            return item;
          });
        } else {
          this.$message.error(res.msg);
        }
      });
      supplierGetList({
        limit: 10000,
        comp_id: this.$store.getters.userInfo.compId,
        is_showAll: 1,
        user_id: this.$store.getters.userInfo.userId,
      }).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "supplier_id") {
              item.options = res.data.map((item) => {
                return {
                  label: item.id + "-" + item.nick_name,
                  value: item.id,
                };
              });
            }
            return item;
          });
        } else if (res.code == 0) {
          this.$message.error(res.data.msg || "获取供应商数据源失败！");
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/inquirySheet/index.vue